import { render, staticRenderFns } from "./otherStoreRegionPage.vue?vue&type=template&id=3fbc4fa5&scoped=true&"
import script from "./otherStoreRegionPage.vue?vue&type=script&lang=js&"
export * from "./otherStoreRegionPage.vue?vue&type=script&lang=js&"
import style0 from "./otherStoreRegionPage.vue?vue&type=style&index=0&id=3fbc4fa5&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbc4fa5",
  null
  
)

export default component.exports